import { useEffect, useRef } from 'react';

import { useGetContractsQuery } from '@/api/queries/contract';
import { changePaymentStatus } from '@/redux/reducers/paymentsReducer';
import { useAppDispatch } from '@/redux/store';

import { WebsocketEmitters } from '../app/socket';
import { socket } from '../socket/socket';
import { type ResponseContractDataType } from '../types/contract';

const useOpenContractPlusListener = (): void => {
  const dispatch = useAppDispatch();
  const { refetch } = useGetContractsQuery();
  const timerId = useRef<NodeJS.Timeout>();

  useEffect(() => {
    const handlePlusContract = (_: ResponseContractDataType): void => {
      timerId.current = setTimeout(() => {
        refetch();
        dispatch(changePaymentStatus('success'));
      }, 2000);
    };

    socket.on(WebsocketEmitters.OPEN_CONTRACT_PLUS, handlePlusContract);

    return (): void => {
      clearTimeout(timerId.current);
      socket.off(WebsocketEmitters.OPEN_CONTRACT_PLUS, handlePlusContract);
    };
  }, []);
};

export { useOpenContractPlusListener };
